import { Component, computed, input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'sana-shared-training-progress-indicator',
  imports: [
    NgClass
  ],
  templateUrl: './training-progress-indicator.component.html',
  styleUrl: './training-progress-indicator.component.scss'
})
export class TrainingProgressIndicatorComponent {

  completedAmountOfTrainings = input.required<number>();
  expectedAmountOfTrainings = input.required<number>();

  expectedAmountOfTrainingsArr = computed(() => Array.from({ length: Math.max(0, this.expectedAmountOfTrainings()) }));
}
